/**
 * The browser entry point.
 *
 * It imports the stylesheet so the bundler owns both assets, then starts the
 * application. Nothing else happens here: the application is constructed with
 * the element it will own, so the test seam is "call `html()` and compare a
 * string" rather than a running browser.
 */

import './styles/app.css';
import { App } from './app.js';

const root = document.querySelector<HTMLElement>('#app');
if (root === null) {
  throw new Error('Skills Manager needs an element with id "app" to render into.');
}

new App(root).start();